import { TG_SUPPORT } from "@constants";
import styles from "./login.module.scss";

export const NotVerified = () => {
  return (
    <div className={styles.notVerified}>
      <p>Аккаунт не подтвержден.</p>
      <p>Для подтверждения обратитесь к</p>
      <a href={`https://t.me/${TG_SUPPORT}`}>@{TG_SUPPORT}</a>
    </div>
  );
};

export const Blocked = () => {
  return (
    <div className={styles.notVerified}>
      <p>Ваша учетная запись заблокирована.</p>
      <p>Обратитесь в службу поддержки для уточнения деталей</p>
      <a href={`https://t.me/${TG_SUPPORT}`}>@{TG_SUPPORT}</a>
    </div>
  );
};

export const RefusalToActivate = () => {
  return (
    <div className={styles.notVerified}>
      <p>Ваша заявка на подключение отклонена.</p>
      <p>Обратитесь в службу поддержки для уточнения деталей</p>
      <a href={`https://t.me/${TG_SUPPORT}`}>@{TG_SUPPORT}</a>
    </div>
  );
};
